import { useContext } from 'react';

import { SupportDrawerContext } from './support-drawer-context';

// ----------------------------------------------------------------------

export function useSupportDrawerContext() {
  const context = useContext(SupportDrawerContext);

  if (!context) throw new Error('useSupportDrawerContext must be use inside SupportDrawerProvider');

  return context;
}
